import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

export const VAPID_KEY = "BAkRet3D3CPDYJPlfggI9dZ3tgRFxsHlAun5eyrNY-N3c_t4ZemfRzxCnsRaxC2dsfr7otEy6uT8v5mFe7wFQ18";

const firebaseConfig = {
  apiKey: "AIzaSyDcu4A12ZvBRGGWyvGtdTdaTEp6FIpeN2w",
  authDomain: "vider-3fc4d.firebaseapp.com",
  projectId: "vider-3fc4d",
  storageBucket: "vider-3fc4d.firebasestorage.app",
  messagingSenderId: "762717377796",
  appId: "1:762717377796:web:08ce567ee6a39495bdac51"
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

export const requestForToken = async () => {
  return getToken(messaging, {
    vapidKey: VAPID_KEY,
    serviceWorkerRegistration: await navigator.serviceWorker.register('/firebase-messaging-sw.js')
  })
    .then((currentToken) => {
      if (currentToken) {
        console.log('currentToken::', currentToken);
        return currentToken;
      } else {
        alert(
          "No registration token available. Request permission to generate one."
        );
        return null;
      }
    })
    .catch((err) => {
      alert("An error occurred while retrieving token - " + err);
      return null;
    });
};

// onMessage(messaging, ({ notification }) => {
//   new Notification(notification.title, {
//     body: notification.body,
//     icon: 'https://vider.in/images/vider-favicon.png',
//   });
// });



